







































































import VueOptions from '@utils/VueOptions'
import ChartUtility from '@utils/ChartUtility'
import BoxChart from '@ui/Dashboard/Charts/BoxChart'

settings =
  name: 'PersonasProfilesBarChart'

  vue:
    props: ['title', 'data', 'max', 'showFilters', 'options']

    components: {
      BoxChart,
    }

    data: ->
      chart: null
      selectedValueField: 'score'
      selectedPersonaCategory: null
      selectedPersonaKeys: []

    computed:
      max_: ->
        @max || 20

      options_: ->
        @options || {}

      dataByValueField: ->
        @filteredData.map((persona) => persona[@selectedValueField]) unless @isEmptyValue(@filteredData)

      optionsForCategories: ->
        personas = @data[@selectedValueField]
        personas = [] if @isEmptyValue(personas)
        @uniq(@flatten(@pluck(personas, 'categories'))).sort()

      optionsForBrands: ->
        personas = @data[@selectedValueField]
        personas = [] if @isEmptyValue(personas)
        personas = [...personas]
        personas = personas.filter((persona) => @selectedPersonaCategory in persona.categories) if @selectedPersonaCategory
        personas.sort((a, b) => b[@selectedValueField] - a[@selectedValueField])

      filteredData: ->
        personas = @data[@selectedValueField]
        personas = [] if @isEmptyValue(personas)
        personas = [...personas]
        personas = personas.filter((persona) => @selectedPersonaCategory in persona.categories) if @selectedPersonaCategory
        filteredPersonas = personas.filter((persona) => persona.key in @selectedPersonaKeys)
        notFilteredPersonas = personas.filter((persona) => persona.key not in @selectedPersonaKeys)
        [...filteredPersonas, ...notFilteredPersonas]

    methods:
      cleanUp: ->
        @chart?.destroy()

      draw: ->
        data = @dataByValueField.slice(0, @max_)
        labels = @filteredData.map((persona) => persona.name).slice(0, @max_)
        keys = @filteredData.map((persona) => persona.key).slice(0, @max_)

        # await images to load before drawing chart to avoid 'broken state'
        # when drawing images on the chart
        images = await Promise.all(
          @filteredData.map((persona) =>
            return null unless persona.logo
            new Promise((resolve, reject) =>
              image = new Image()
              image.onload = () => resolve(image)
              image.onerror = () => resolve(null)
              image.src = persona.logo
            )
          )
        )

        max = ChartUtility.maxValue data

        @cleanUp()
        @chart = new Chart(@$refs.chart, {
          type: 'bar'
          data: {
            labels: labels
            datasets: [{
              data: data
              borderRadius: 2
              barThickness: 40
              maxBarThickness: 40
              backgroundColor: (context) =>
                alpha = context.raw / max
                alpha = 1 if alpha > 1
                alpha = 0.5 if alpha < 0.5
                rgb = '52, 144, 220'
                rgb = '242, 121, 53' if @selectedPersonaKeys and keys[context.dataIndex] in @selectedPersonaKeys
                "rgba(#{rgb}, #{alpha.toFixed(1)})"
            }]
          }
          options: {
            aspectRatio: 1.4
            interaction: {
              mode: 'index'
              intersect: false
            }
            layout: {
              padding: {
                top: 32
                bottom: 72
              }
            }
            scales: {
              x: {
                grid: {
                  display: false
                }
                ticks: {
                  autoSkipPadding: 1
                  callback: (value) ->
                    label = @getLabelForValue(value)
                    return label.substring(0, 12) + '...' if label?.length > 12
                    label
                }
              }
              y: {
                ticks: {
                  autoSkip: false
                  afterBuildTicks: (axis) =>
                    axis.ticks.push 100 unless 100 in axis.ticks
                    axis.ticks.sort((a, b) => a - b)
                  color: (context) =>
                    if context.tick?.value is 100
                      ChartUtility.COLORS.orange
                  font: (context) =>
                    if context.tick?.value is 100
                      { weight: 'bold' }
                }
              }
            }
            plugins: {
              legend: {
                display: false
              }
              datalabels: {
                formatter: (value) =>
                  if @selectedValueField is 'density'
                    @$options.filters.formatNumberShort(value) + '%'
                  else
                    @$options.filters.formatNumberShort value
                color: (context) =>
                  if @selectedPersonaKeys and keys[context.dataIndex] in @selectedPersonaKeys
                    ChartUtility.COLORS.orange
                  else
                    ChartUtility.COLORS.blue
                anchor: 'end'
                align: 'end'
                font: {
                  weight: 'bold'
                }
              }
            }
            ...(@options_.chartOptions)
          }
          plugins: [
            ChartDataLabels
            {
              id: 'avg-line'
              afterDraw: (chart) =>
                ctx = chart.ctx
                yAxis = chart.scales.y;
                yValue = yAxis.getPixelForValue(100)

                ctx.save()
                ctx.beginPath()
                ctx.setLineDash([5, 5])
                ctx.moveTo(chart.chartArea.left, yValue)
                ctx.lineTo(chart.chartArea.right, yValue)
                ctx.strokeStyle = ChartUtility.COLORS.orange
                ctx.lineWidth = 1.5
                ctx.stroke()
                ctx.restore()

                ctx.save()
                ctx.fillStyle = ChartUtility.COLORS.orange
                ctx.font = 'bold 12px Arial'
                ctx.textAlign = 'right'
                ctx.fillText('AVG', chart.chartArea.right, yValue - 8)
                ctx.restore()
            }
            {
              id: 'brand-logos'
              afterDraw: (chart) =>
                ctx = chart.ctx
                xAxis = chart.scales.x
                yAxis = chart.scales.y

                xAxis.ticks.forEach (value, index) =>
                  return unless images[index]
                  y = yAxis.getPixelForTick(0)
                  x = xAxis.getPixelForTick(index)
                  barWidth = chart.getDatasetMeta(0).data[index].width
                  image = images[index]

                  # Calculate the size maintaining the aspect ratio
                  aspectRatio = image.width / image.height
                  size = barWidth
                  width = size
                  height = size / aspectRatio

                  # Center the image horizontally and adjust the vertical position
                  left = x - (width / 2)
                  top = y + 48 + (24 - (height / 2))

                  ctx.drawImage(image, left, top, width, height)
            }
          ]
        })

export default VueOptions.vue settings
